<template>
  <section id="home" class="content">
    <SkAnimation v-if="loading" :tab="false" :thumb="false"/>
    <div class="mediaCnt" v-else>
      <div class="mediaItem addMedia" v-on:click="addMedia">
        + Add image
      </div>
      <template v-if="dataDetail.items">
        <div class="mediaItem" v-for="(media, index) in dataDetail.items" :key="index"
          :style="{'background-image': `url(${media.media.imageSm})`}">
          <div class="delete" v-on:click="deleteImage(media)"/>
          <div class="edit" v-on:click="editImage(media)"/>
        </div>
      </template>
    </div>

    <MediaSelector v-if="showMediaSelector" v-on:close="showMediaSelector = false"
      v-on:ok="imageOk"/>
    <Confirmation v-if="deleteConfirmation" :title="deleteTitle" :desc="deleteDesc"
      v-on:cancel="deleteConfirmation = false" v-on:ok="deleteNow"/>
  </section>
</template>

<script>
import { mapActions } from 'vuex';
import Confirmation from '@/components/Confirmation.vue';
import SkAnimation from '@/components/SkAnimation.vue';
import MediaSelector from '@/components/MediaSelector.vue';

export default {
  name: 'gallery',
  components: {
    SkAnimation, MediaSelector, Confirmation,
  },
  data() {
    return {
      loading: true,
      dataDetail: null,
      showMediaSelector: false,
      deleteConfirmation: false,
      deleteTitle: '',
      deleteDesc: '',
      imageWillEdit: null,
      imageWillDelete: null,
    };
  },
  methods: {
    ...mapActions([
      'chTitle', 'chCGB',
    ]),
    fieldChanged(e, field) {
      this.model[field] = e.target.innerHTML;
    },
    imageOk(media) {
      this.showMediaSelector = false;
      const formData = {
        mediaId: media.id,
        parentId: this.dataDetail.id,
      };
      if (this.imageWillEdit) {
        formData.id = this.imageWillEdit.id;
      }
      this.$http.post(this.$config.uri('gallery/save'), formData)
        .then((response) => {
          this.getData();
        });
    },
    getData() {
      this.loading = true;
      this.$http.get(this.$config.uri(`gallery/${this.$route.params.slug}`)).then((response) => {
        this.loading = false;
        this.dataDetail = (response.data.status === 200) ? response.data.data : null;
        if (this.dataDetail) {
          this.chTitle(`Gallery - ${this.dataDetail.name}`);
        }
      });
    },
    deleteImage(image) {
      this.imageWillDelete = image;
      this.deleteTitle = 'Delete Image';
      this.deleteDesc = 'Are you sure you want to delete this image from gallery?';
      this.deleteConfirmation = true;
    },
    deleteNow() {
      this.deleteConfirmation = false;
      this.$http.get(this.$config.uri(`gallery/${this.imageWillDelete.id}/delete`))
        .then((response) => {
          this.getData();
        });
    },
    addMedia() {
      this.imageWillEdit = null;
      this.showMediaSelector = true;
    },
    editImage(image) {
      this.imageWillEdit = image;
      this.showMediaSelector = true;
    },
  },
  mounted() {
    this.chTitle('Gallery');
    this.chCGB(false);
    this.getData();
  },
};
</script>

<style scoped lang="scss">
  .mediaCnt{
    display: flex;
    flex-wrap: wrap;
    margin: 0 -10px;
    padding: 20px 0;
    .mediaItem{
      width: calc(20% - 20px);
      height: 200px;
      margin: 0 10px;
      background-size: cover;
      background-color: #eee;
      background-position: center;
      background-repeat: no-repeat;
      border-radius: 5px;
      margin-bottom: 20px;
      box-shadow: 2px 2px 2px rgba(0,0,0,.1);
      transition: all .2s ease;
      box-sizing: border-box;
      position: relative;
      &.addMedia{
        color: #767676;
        text-align: center;
        padding-top: 90px;
        font-size: 20px;
        cursor: pointer;
        background-image: url(../assets/image-white.png);
        background-size: 100px auto;
        background-position: center;
        background-repeat: no-repeat;
        &:hover{
          background-color: #cfd7e2;
        }
      }
      &:hover{
        box-shadow: 2px 2px 4px rgba(0,0,0,.3);
      }
      .delete, .edit{
        width: 30px;
        height: 30px;
        background-color: rgba(0,0,0,.1);
        border-radius: 50%;
        position: absolute;
        right: 10px; top: 10px;
        background-image: url(../assets/delete.png);
        background-size: 18px auto;
        background-position: center;
        background-repeat: no-repeat;
        &:hover{
          cursor: pointer;
          background-color: rgba(0,0,0,.3);
        }
      }
      .edit{
        right: 45px;
        background-image: url(../assets/edit.png);
      }
    }
  }
</style>
